import { render } from "./UserCards.vue?vue&type=template&id=03bee278&scoped=true"
import script from "./UserCards.vue?vue&type=script&lang=js"
export * from "./UserCards.vue?vue&type=script&lang=js"

import "./UserCards.vue?vue&type=style&index=0&id=03bee278&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03bee278"]])

export default __exports__